// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","379":"1bfc9850"}[chunkId] + "-" + {"125":"7d40c09f25175f50ea26","293":"6dfea42a8a38ebbec693","379":"18571ab3d97fbad2c5b1"}[chunkId] + ".js";
};